import React from 'react';
const CircleNav = (props) => {
    return ( 
             <button className='circlecta-cont'   onClick={props.onClick}>
                <img src={props.img2} alt={props.icontext2}></img>
            </button>
     );
}
 
export default CircleNav;